import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Service composable that provides access to service-related state
 */
export function useService() {
  const store = useStore();

  // Service getters
  const pendingServices = computed(() => store.getters['service/GET_PENDING_SERVICE']);
  const isLoading = computed(() => store.getters['service/GET_LOADING_STATUS']);
  const systemMessage = computed(() => store.getters['service/GET_SYSTEM_MESSAGE']);
  const systemMessageTimeout = computed(() => store.getters['service/GET_SYSTEM_MESSAGE_TIMEOUT']);

  // Service mutations/actions
  const setSystemMessageTimeout = (timeout) => store.commit('service/setSystemMessageTimeout', timeout);

  return {
    // Getters
    pendingServices,
    isLoading,
    systemMessage,
    systemMessageTimeout,
    
    // Actions/Mutations
    setSystemMessageTimeout,
  };
}
